import { Organization, Role } from "myfitworld-model";
import ContentFilterValues from "src/model/ContentFilter";


export function filterBySwitch<T extends Record<string, any>>({
  content,
  filter,
  organization,
  platformId,
  userId,
  userRole,
  endpoint,
}: {
  content: T[];
  filter: ContentFilterValues;
  platformId: string;
  organization?: Organization;
  userId: string;
  userRole: Role;
  endpoint?: string;
}) {
  const {
    archived: showArchived = false,
    showMFWOriginals = false,
    showORGOriginals = false,
    showPremium = false,
    showPublic = false,
    showMyMfwNet = false,
    isLockedContentDisplayed = false,
  } = filter;

  const mfwId = process.env.REACT_APP_MFW_ORGANIZATION_ID;
  const isWhiteLabel = mfwId !== platformId;
  const isPlatformOrg = organization?.id === mfwId;

  return content.filter(item => {
    const isArchived = !!item.archived;
    const isAuthor = item.authorId === userId;
    const isOrgContent = item.organizationId === organization?.id && item.orgContent === true;
    const isMfwOrgContent = item.organizationId === mfwId;
    const isPublic = item.isPublic === true;
    const isPremium = item.premiumContent === true;
    const isLocked = item.isLockedContent === true;
    const isNotOrgContent = item.orgContent !== true;

    // ARCHIVED
    if (isArchived !== showArchived) return false;

    // Locked (Marketplace) content
    if (isLockedContentDisplayed) {
      return isAuthor && isLocked;
    }

    // My MFW Net content
    if (showMyMfwNet) {
      return isAuthor && isPublic;
    }

    // Premium content
    if (showPremium) {
      return isPlatformOrg ? isPremium : isPremium && item.organizationId === organization?.id;
    }

    // Public content
    if (showPublic) {
      const isAccordingToPlatform = isWhiteLabel
        ? item.organizationId === platformId
        : item.isWhiteLabel === false;

      return isPublic && isAccordingToPlatform;
    }

    // Author’s own content that is not org content
    if (isAuthor && isNotOrgContent) {
      return true;
    }

    // MFW Original content
    const isMfwOriginal = (() => {
      if (!showMFWOriginals) return false;

      if (userRole === Role.SuperAdmin) {
        return isMfwOrgContent;
      }

      if (endpoint === 'exercises') {
        return isMfwOrgContent || (isAuthor && !item.orgContent);
      }

      return (isMfwOrgContent && !isPremium) || (isAuthor && !item.orgContent);
    })();

    if (isMfwOriginal) return true;

    // Org Original content
    if (showORGOriginals && (isOrgContent || isAuthor)) {
      return true;
    }

    // Default: filtered out
    return false;
  });
}